import { colors } from "@material-ui/core";
import React from "react";

import { Button } from "@/design-system/components/Button/Button";

import { GoogleAdsIcon } from "@/components/icons/themes/logos";
import { ConfigureDestinationsModal } from "@/destinations/modals/ConfigureDestinationsModal";
import { GoogleOAuthConfigModal } from "@/destinations/modals/GoogleOAuthConfigModal";
import useFeatureFlags from "@/hooks/useFeatureFlag";
import { DestinationConfigRow } from "../shared/ConfigPageRow";

const ConfigurationModal = ({
  destination,
  open,
  onClose,
  handleUpdateConfigureDest,
  existingConfig,
}) => {
  const { settings: allSettings } = existingConfig;

  const flag = useFeatureFlags();
  const googleAdsEnhancedConversionsPassthrough = flag(
    "googleAdsEnhancedConversionsPassthrough",
  );

  return (
    <ConfigureDestinationsModal
      limitSettings={
        googleAdsEnhancedConversionsPassthrough
          ? [
              "operatingAccountId",
              "productDestinationId",
              "enableEnhancedConversionsPassthrough",
            ]
          : ["operatingAccountId", "productDestinationId"]
      }
      open={open}
      includeHeader={true}
      settings={allSettings}
      dest={destination}
      onClose={onClose}
      onSave={(_dest, _id, newConfig) => handleUpdateConfigureDest(newConfig)}
      existingConfig={existingConfig}
    />
  );
};

const ConfigurationRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const idSet = "operatingAccountId" in settings;

  return (
    <DestinationConfigRow
      name="Configuration"
      textColor={idSet ? "" : colors.red[600]}
      labelText={idSet ? "Configured" : "Not configured"}
      onOpenConfigModal={() => setConfigModalOpen("credentials")}
    />
  );
};

const OAuthRow = ({ setConfigModalOpen, existingConfig }) => {
  const settings = existingConfig.settings || {};
  const oauthConfigured = "oauthToken" in settings;

  // only show the oauth flow if we're in server side mode
  var enable_row = existingConfig.connection_mode !== "server" ? true : false;

  // this comes from the google app verification process. They want links that
  // say Google Ads, to also have the icon. But also not show the icon alone
  // afaict. So we show <icon> Connect with Google if oauth is not configured.
  const loginButton = (
    <Button
      variant="outline"
      size="sm"
      className="border-[#4285F4]"
      leadingIcon={!oauthConfigured && <GoogleAdsIcon className="h-4 w-4" />}
      onClick={setConfigModalOpen}
    >
      {oauthConfigured ? "Reconnect" : "Connect with Google Ads"}
    </Button>
  );

  return (
    <DestinationConfigRow
      name="Access permission"
      disabled={enable_row}
      buttonComponent={loginButton}
      textColor={oauthConfigured ? "" : colors.red[600]}
      labelText={oauthConfigured ? "Connected" : "Not Connected"}
      onOpenConfigModal={setConfigModalOpen}
    />
  );
};

const CONFIGURATION = "CONFIGURATION";
const OAUTH = "OAUTH";

const Rows = {
  [CONFIGURATION]: ConfigurationRow,
  [OAUTH]: OAuthRow,
};

const Modals = {
  [CONFIGURATION]: ConfigurationModal,
  [OAUTH]: GoogleOAuthConfigModal,
};

const RowOrder = [CONFIGURATION, OAUTH];

const GoogleDataManagerConversionAPIConfig = {
  Rows,
  RowOrder,
  Modals,
};

export default GoogleDataManagerConversionAPIConfig;
